import {Navigate, useParams} from "react-router-dom";

/**
 * Legacy URL: subscriptions list and deep links used `/products/subscriptions/sales-and-insights/:id`.
 * Sales & insights lives on the edit flow; redirect preserves bookmarks and external links.
 */
export function SubscriptionSalesInsightsRedirect() {
  const {id} = useParams<{id: string}>();

  if (!id) {
    return <Navigate replace to="/products?activeTab=subscriptions" />;
  }

  return (
    <Navigate
      replace
      to={`/products/subscriptions/edit/${id}?activeTab=salesAndInsights`}
    />
  );
}
